import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  buttonLabel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.25rem',
    fontWeight: 600,
  },
  
  icons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  spin: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: `$spin 1s infinite linear`,
  },
  
  '@keyframes spin': {
    '0%': {
      transform: 'rotateZ(0deg)',
    },
    '100%': {
      transform: 'rotateZ(360deg)',
    },
  },
  
}))

export default styles
